<template>
     <div class="collapsible">
                        <div class="trigger">
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <div class="trigger-icon">
                                        <font-awesome-icon icon="tags" style="color:#fff;height:100%"/>
                                    </div>
                                </div>
                                <div class="col">
                                    <div class="trigger-content">Keywords </div>
                                </div>
                                <div class="col-auto touchpad"  @click="collapse">
                                    <div class="trigger-indicator">
                                        <font-awesome-icon v-if="hide" icon="chevron-down" style="color:#fff; height:24px"/>
                                        <font-awesome-icon v-else icon="chevron-up" style="color:#fff; height:24px"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div :class="[{'hide':hide},'body']">
                            <div class="card" style="background:transparent">
                                    <div class="card-content">
                                        <div class="container">
                                            <div class="row element">
                                                <div class="col-auto content-col">
                                                    <div class="keywords">

                                                        <div :class="[{'selectedKeyword':index==keywordSelected},'chip iconed touchpad']"  v-for="(keyword,index) in keywords" :key="index" @click="setKeyword(index)">
                                                            {{keyword}} 
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            </div>                                   
                        </div>
    </div>
</template>

<script>

import { library } from '@fortawesome/fontawesome-svg-core'
import { faTags, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

library.add(faTags)
library.add(faChevronDown)
library.add(faChevronUp)

export default {
    name: 'keywordsNotes',
    props:['keywords','keywordSelected'],
    data () {
        return {
           
            hide:false
        }
    },
    beforeMount(){
       
        console.log(this.keywords)
        console.log(this.keywordSelected)
    },
    methods:{
        setKeyword(index){
            this.$emit('setKeyword',index);
        },
        collapse(){
            this.hide = !this.hide
        }
    }
}
</script>

<style scoped>
.touchpad{
    cursor: pointer;
}
.selectedKeyword{
   background:#00B99E;
    color:#fff;
}
.collapsible .trigger {
    cursor: default;
}
</style>
